export default __webpack_public_path__ + "static/media/Dry Fruits & Vrat Items.d8206e01.png";